var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from "react";
import { useTheme } from "@mui/material";
/**
 * This context is used to override the paper background color.
 */
var PaperBackgroundContext = createContext(null);
export function usePaperBackgroundContext() {
    var context = useContext(PaperBackgroundContext);
    if (context === null) {
        throw new Error('usePaperBackgroundContext must be used within a PaperBackgroundContext');
    }
    return context;
}
export function PaperBackgroundContextProvider(props) {
    var theme = useTheme();
    var _a = useState(theme.palette.background.paper), paperBackgroundColor = _a[0], setPaperBackgroundColor = _a[1];
    return (_jsx(PaperBackgroundContext.Provider, __assign({ value: { paperBackgroundColor: paperBackgroundColor, setPaperBackgroundColor: setPaperBackgroundColor } }, { children: props.children })));
}
